import { WebApiRequest, HTTP_GET, HTTP_PUT } from "tools/webservice";
import FeaturePermissionCodes from "typeConstants/featurePermissionCodes";

export const getFeaturePermissionStates = (customerNumber: number, code: FeaturePermissionCodes, successCallback: (data: string[]) => void, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/feature-permission/${customerNumber}/${code}/states`,
  successCallback,
  mountedRef,
});

export const updateFeaturePermissionStates = (customerNumber: number, code: FeaturePermissionCodes, states: string[], successCallback: () => void, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/feature-permission/${customerNumber}/${code}/states`,
  payload: states,
  successCallback,
  mountedRef,
});